<a [routerLink]="route()" [queryParamsHandling]="'merge'">
  <ng-container *transloco="let t">
    <app-selectable-text
      [theme]="theme()"
      [text]="t(categoryLocalizationKey()).toUpperCase()"
      [isSelected]="isSelected()"
    ></app-selectable-text>
  </ng-container>
</a>
